import React, { useEffect } from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { useUpdateAccountGroups } from "@/features/accounts/account-group/hooks/use-update-account-groups";
import { SimpleForm } from "@/shared/components/text-box/simple-form";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";


interface Props {
  onTapCloseModal: () => void;
  onTapCompleteModal: () => void;
}

export const UpdateAccountGroupNameModal = ({ onTapCloseModal, onTapCompleteModal }: Props) => {
  const {
    targetAccountGroup,
  } = useAccountGroupsContext();

  const {
    accountGroupName,
    setAccountGroupName,
    isActivateUpdateButton,
    onChangeGroupName,
    updateAccountGroups,
    onChangeUpdateButtonState,
  } = useUpdateAccountGroups({ onTapCompleteModal });

  // 初回レンダリング時のみ
  useEffect(() => {
    setAccountGroupName(targetAccountGroup.accountGroupsName);
  }, []);

  useEffect(() => {
    onChangeUpdateButtonState(accountGroupName);
  }, [accountGroupName]);


  return (
    <BasePageModal
      handleClose={onTapCloseModal}
      title="グループ名の変更"
      className="md-group-edit"
      bottomChildren={
        <BaseRoundButton
          buttonText="グループ名を変更"
          isActive={isActivateUpdateButton}
          onClick={() => updateAccountGroups(
            targetAccountGroup.accountGroupId,
            accountGroupName.slice(0, 50).trim(),
            undefined,
            undefined,
          )}
        />
      }
      disableOverlayClose={true}
    >
      <h2>グループ名を変更できます</h2>
      <ul>
        <li>
          <SimpleForm
            value={accountGroupName}
            placeholder="グループ名を入力してください"
            onChange={onChangeGroupName}
          />
        </li>
      </ul>
    </BasePageModal>
  );
};
